import { useEffect, useRef, MutableRefObject } from 'react';
import { CanjeStatus } from './useCanjeStatus';

/**
 * Hook para hacer foco al primer elemento dentro del
 * formulario de canje luego de que se terminen de cargar
 * los datos para el proceso de canje.
 * @param status: estado del proceso de canje.
 * @param isLoading: indicación de si se terminaron
 * de cargar los datos necesario para el proceso de canje.
 */
export const useFocusFirst = (status: CanjeStatus, isLoading: boolean) => {
  const elementRef: MutableRefObject<HTMLParagraphElement | null> = useRef(null);

  const firstElementRef = (current: HTMLParagraphElement | null) => {
    if (elementRef && !elementRef.current) {
      elementRef.current = current;
    }
  };

  useEffect(() => {
    if (status !== CanjeStatus.INICIAL && !isLoading) {
      elementRef?.current?.focus();
    }
  }, [isLoading, status, elementRef]);

  const reset = () => {
    if (elementRef) elementRef.current = null;
  };

  return [firstElementRef, reset] as const;
};
